import {
  useProducts,
  useProject,
} from '@customink/project-service-react-components';
import type { ProjectItem as ProjectItemType } from '@customink/project-service-types';

export const useAllProducts = () => {
  const {
    data: project,
    isLoading: isLoadingProject,
    isFetching: isFetchingProject,
    isError: isProjectError,
    error: projectError,
  } = useProject();

  if (isProjectError) {
    throw new Error(
      `Error loading project: ${JSON.stringify(projectError, null, 2)}`,
    );
  }

  const productIds = project?.items?.reduce(
    (acc: number[], projectItem: ProjectItemType) => {
      if (projectItem.product?.colorId) {
        acc.push(projectItem.product.colorId);
      }
      return acc;
    },
    [],
  );

  const {
    data: products,
    isLoading: isLoadingProducts,
    isFetching: isFetchingProducts,
    isError: isProductsError,
    error: productsError,
  } = useProducts({
    colorIds: productIds || [0],
  });

  if (isProductsError) {
    throw new Error(
      `Error loading products: ${JSON.stringify(productsError, null, 2)}`,
    );
  }

  return {
    products,
    isLoading: isLoadingProject || isLoadingProducts,
    isFetching: isFetchingProject || isFetchingProducts,
  };
};
